import { takeEvery, call } from 'redux-saga/effects';
import { REGISTRATION_NOTIFICATION } from 'shared_redux/actions';
import { displaySuccessAlert, displayErrorAlert, displayAlert } from 'services/alerts';

/**
 * Saga to handle notification actions
 * Displays alerts based on notification type
 */
function* handleNotification(action) {
    const { message, notificationType } = action;
    
    if (notificationType === 'success') {
        yield call(displaySuccessAlert, message);
    } else if (notificationType === 'error') {
        yield call(displayErrorAlert, message);
    } else {
        yield call(displayAlert, message);
    }
}

/**
 * Notification saga that watches for notification actions
 */
export default function* NotificationsSaga() {
    yield takeEvery(REGISTRATION_NOTIFICATION, handleNotification);
} 